import React, { useState, useEffect, useRef } from 'react';
import ButtonsConditions from '../ButtonsConditions/ButtonsConditions';
import ExteriorConditions from '../ExteriorConditions/ExteriorConditions';
import ScreenCondition from '../ScreenCondition/ScreenCondition';
import BackButton from '../../components/BackButton/BackButton';
import axios from 'axios';

const ConditionsContainer = ({ onConditionsSelect, onBack }) => {
  const [buttonsCondition, setButtonsCondition] = useState(null);
  const [exteriorCondition, setExteriorCondition] = useState(null);
  const [screenCondition, setScreenCondition] = useState(null);

  // Crear referencias para cada sección
  const exteriorRef = useRef(null);
  const screenRef = useRef(null);
  const tagend = window.tagend;

  // Verifica si todas las condiciones han sido seleccionadas
  useEffect(() => {
    if (
      buttonsCondition !== null &&
      exteriorCondition !== null &&
      screenCondition !== null
    ) {
      console.log("Enviando condiciones:", {
        buttonsCondition,
        exteriorCondition,
        screenCondition,
      });

      const bodyGrade = {
        turns_on_and_buttons_ok: buttonsCondition,
        exterior_is_ok: exteriorCondition,
        cameras_and_touchscreen: screenCondition,
      };

      axios
        .post(
          "https://api.quieromac.com/retomas/inventory/celucambio/grade",
          bodyGrade
        )
        .then((response) => {
          const gradeResult = response.data.data;
          onConditionsSelect(gradeResult || null, buttonsCondition, exteriorCondition, screenCondition);
          if (window.plausible) {
            window.plausible(`functional-evaluation-completed${tagend}`);
          } else {
            console.error("Plausible is not defined");
          }
        })
        .catch((error) => {
          console.error("Error al obtener el grade:", error);
          onConditionsSelect(null, buttonsCondition, exteriorCondition, screenCondition);
        });
    }
  }, [buttonsCondition, exteriorCondition, screenCondition, onConditionsSelect]);

  // Función para desplazarse al siguiente componente
  const scrollToNext = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="conditions-container">
      <h1>Evaluación del celular</h1>

      <div className="condition-section">
        <ButtonsConditions 
          onSelect={(value) => {
            console.log("Buttons condition seleccionada:", value);
            setButtonsCondition(value);
            // Desplazar a la sección exterior al seleccionar
            scrollToNext(exteriorRef);
          }} 
          selectedCondition={buttonsCondition} 
        />
      </div>

      <div className="condition-section" ref={exteriorRef}>
        <ExteriorConditions 
          onSelect={(value) => {
            console.log("Exterior condition seleccionada:", value);
            setExteriorCondition(value);
            // Desplazar a la sección de pantalla al seleccionar
            scrollToNext(screenRef);
          }} 
          selectedCondition={exteriorCondition} 
        />
      </div>

      <div className="condition-section" ref={screenRef}>
        <ScreenCondition 
          onSelect={(value) => {
            console.log("Screen condition seleccionada:", value);
            setScreenCondition(value);
          }} 
          selectedCondition={screenCondition} 
        />
      </div>

      <BackButton onClick={onBack} />
    </div>
  );
};

export default ConditionsContainer;
